import type { IconComponent } from "./types";

export const Menu: IconComponent = ({ ref, color = "currentColor", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ref={ref} {...props}>
      <title>Menu</title>
      <path
        fill={color}
        d="M21 17a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h18Zm0-6a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h18Zm0-6a1 1 0 1 1 0 2H3a1 1 0 0 1 0-2h18Z"
      />
    </svg>
  );
};
Menu.displayName = "Menu";
Menu.alias = ["hamburger", "nav"];
